import type { SourceSpecification } from "maplibre-gl";

export const SOURCES = {
  AIRCRAFT: "aircraft-source",
  TRAILS: "trails-source",
  TRACKS: "tracks-source",
  STATIONS: "stations-source",
  PDAR: "pdar-source",
  PDAR_AOA: "pdar-aoa-source",
  PRIMITIVES: "primitives-source",
  HEATMAP: "heatmap-source",
} as const;

export const sources: Record<string, SourceSpecification> = {
  [SOURCES.AIRCRAFT]: {
    type: "geojson",
    data: { type: "FeatureCollection", features: [] },
  },
  [SOURCES.TRAILS]: {
    type: "geojson",
    lineMetrics: true,
    data: { type: "FeatureCollection", features: [] },
  },
  [SOURCES.TRACKS]: {
    type: "geojson",
    lineMetrics: true,
    data: { type: "FeatureCollection", features: [] },
  },
  [SOURCES.STATIONS]: {
    type: "geojson",
    data: { type: "FeatureCollection", features: [] },
  },
  [SOURCES.PDAR]: {
    type: "geojson",
    data: { type: "FeatureCollection", features: [] },
  },
  [SOURCES.PDAR_AOA]: {
    type: "geojson",
    lineMetrics: true,
    data: { type: "FeatureCollection", features: [] },
  },
  [SOURCES.PRIMITIVES]: {
    type: "geojson",
    lineMetrics: true,
    data: { type: "FeatureCollection", features: [] },
  },
  [SOURCES.HEATMAP]: {
    type: "geojson",
    data: { type: "FeatureCollection", features: [] },
  },
};
